import {Col, Container, Row} from "reactstrap";
import {Breadcrumbs} from "../../AbstractElements";
import {useEffect, useState} from "react";
import MyProfileEdit from "./MyProfile";
import {API_USER_CURRENT} from "../../api/service";
import axios from "axios";

const ViewsSettingAkun = () => {
    const [accountData, setAccountData] = useState(
        {
            id: 0,
            full_name: "",
            login_username: "",
            login_password: "",
            role: 0
        }
    )

    useEffect(() => {
        axios.get(API_USER_CURRENT, {withCredentials: true}).then((r) => {
            if (r.status === 200) {
                return r.data
            }
        }).then((json) => {
            const serverAccountData = json.data.data[0]
            setAccountData({
                ...accountData,
                ...serverAccountData
            })
        })
    }, [])


    return (
        <>
            <Breadcrumbs mainTitle="User Edit" parent="Users" title="User Edit"/>
            <Container fluid={true}>
                <div className="edit-profile">
                    <Row>
                        <Col xl="12">
                            <MyProfileEdit accountData={accountData} setAccountData={setAccountData}/>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    )
}

export default ViewsSettingAkun